import React from "react";
import { useLocale } from "@/context/LocaleContext";

class ErrorBoundaryInner extends React.Component<{ children: React.ReactNode; t: (k: string) => string }, { error: Error | null }> {
  constructor(props: any) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: any) {
    console.error("Unhandled error in UI:", error, info);
  }

  render() {
    const t = (this.props as any).t || ((k: string) => k);
    if (this.state.error) {
      return (
        <div style={{ padding: 24, color: "#fff", background: "#111" }}>
          <h2>{t("error.app")}</h2>
          <pre style={{ whiteSpace: "pre-wrap", color: "#f88" }}>{String(this.state.error?.message || this.state.error)}</pre>
          <details style={{ color: "#fff" }}>
            <summary>Stack</summary>
            <pre style={{ whiteSpace: "pre-wrap", color: "#f88" }}>{(this.state.error as any)?.stack}</pre>
          </details>
        </div>
      );
    }
    return this.props.children as any;
  }
}

export function ErrorBoundary(props: { children: React.ReactNode }) {
  const { t } = useLocale();
  return <ErrorBoundaryInner {...props} t={t} />;
}
